import useAuth from "minimals-template/components/@hooks/useAuth"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSearchParam } from "lib/@hooks/use-search-param"
import { useDemand } from "lib/authorization/use-demand"

export function useApplicationSwitcherEligible() {
    const { isAuthenticated } = useAuth()
    const { companionApp } = useBoundContext()
    const [shareParam] = useSearchParam("share", null)
    const notSharing = useDemand("!sharing")
    const isShareLink = shareParam !== null || !notSharing

    if (companionApp || process.env.COMPANION) return false
    if (!isAuthenticated) return false
    return !isShareLink
}
